import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import store from '@/store/store'
import notie from 'notie'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/showman-admin',
      name: 'Admin',
      component: () => import('./views/ShowmanAdmin.vue'),
      meta: {
        requiresAdmin: true,
        description: 'Showman Admin Area'
      }
    },
    {
      path: '/sponsor-a-show',
      name: 'Sponsor a Show',
      component: () => import('./views/SponsorAShow.vue')
    },
    {
      path: '/show-series',
      name: 'Show Series List',
      component: () => import('./views/ShowSeriesList.vue')
    },
    {
      path: '/past-shows',
      name: 'Past Shows',
      component: () => import('./views/pastShows/PastShows.vue')
    },
    {
      path: '/show-series/:show_series',
      name: 'show_series',
      component: () => import('./views/showSeries/ShowSeriesHome_2.vue'),
      children: [
        {
          name: 'show_series.shows',
          path: 'shows',
          alias: '',
          component: () => import('@/views/showSeries/SeriesShows.vue')
        },
        {
          name: 'show_series.results',
          path: 'results',
          alias: '',
          component: () => import('@/views/showSeries/SeriesResults.vue')
        },
        {
          name: 'show_series.standings',
          path: 'standings',
          alias: '',
          component: () => import('@/views/showSeries/SeriesStandings.vue')
        },
        {
          name: 'show_series.standings-secret',
          path: 'standings-secret-52942',
          alias: '',
          component: () => import('@/views/showSeries/SeriesStandings.vue')
        },
        {
          name: 'show_series.join',
          path: 'join',
          alias: '',
          component: () => import('@/views/showSeries/JoinShowSeries.vue')
        },
        {
          name: 'show_series.sanction',
          path: 'sanction',
          alias: '',
          component: () => import('@/views/showSeries/SanctionShow.vue')
        },
        {
          name: 'show_series.admin',
          path: 'admin',
          component: () => import('@/views/showSeries/ShowSeriesAdmin.vue')
        },
        {
          name: 'show_series.sponsor',
          path: 'sponsor',
          component: () => import('@/views/showSeries/SeriesSponsor.vue')
        },
        {
          name: 'show_series.advanced',
          path: 'advanced',
          component: () => import('@/views/showSeries/SeriesAdvancedSettings.vue')
        }
      ]
    },
    {
      path: '/signin',
      name: 'signin',
      component: () => import('./views/Signin.vue'),
      meta: {
        requiresUnAuth: true
      }
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./views/Signup.vue')
    },
    {
      path: '/myProfile',
      name: 'my-profile',
      component: () => import('@/views/MyProfile.vue'),
      meta: {
        requiresAuth: true,
        description: 'access your profile'
      }
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('./views/ForgotPassword.vue')
    },
    {
      path: '/new-show-signup/',
      name: 'new-show-sigup',
      component: () => import('@/views/CreateEvent.vue'),
      meta: {
        // requiresAuth: true,
        description: 'create a new show',
        hideFooter: true,
        hideHelp: true,
        hideHeader: false
      }
    },
    /* {
      path: '/add-show-secret',
      name: 'new-event',
      component: () => import('@/views/NewEvent.vue'),
      meta: {
        requiresAuth: true,
        description: 'create a new show - Secret'
      }
    }, */
    {
      path: '/add-series-secret',
      name: 'new-series',
      component: () => import('@/views/NewSeries.vue'),
      meta: {
        requiresAuth: true,
        description: 'create a new Series'
      }
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/Help.vue')
    },
    {
      path: '/:show',
      // name: 'show',
      component: () => import('./views/showHomepage/ShowHome_2.vue'),
      children: [
        {
          name: 'show.details',
          path: '/',
          alias: '',
          component: () => import('@/views/showHomepage/ShowDetails.vue')
        },
        {
          name: 'show.sponsor',
          path: 'sponsor',
          alias: '',
          component: () => import('@/views/showHomepage/SponsorShowSplit.vue')
        },
        {
          name: 'show.special_registration',
          path: 'special_registration',
          alias: '',
          component: () => import('@/views/showHomepage/SpecialRegistration.vue')
        },
        {
          name: 'show.enter',
          path: 'enter',
          alias: '',
          component: () => import('@/views/showHomepage/EnterShow.vue')
        },
        {
          name: 'show.my_entry',
          path: 'my_entry',
          alias: '',
          component: () => import('@/views/showHomepage/MyEntry.vue')
        }
      ]
    },
    {
      path: '/:show/sponsor-thank-you',
      name: 'sponsor-thank-you',
      component: () => import('./views/SponsorLandingPage.vue')
    },
    {
      path: '/:show/checkout',
      name: 'checkout',
      component: () => import('@/views/Checkout.vue'),
      meta: {
        requiresAuth: true,
        description: 'access the checkout page'
      }
    },
    {
      path: '/:show/admin/',
      name: 'admin',
      component: () => import('@/views/AdminHome.vue'),
      meta: {
        requiresAuth: true,
        description: 'access the admin dashboard',
        layout: 'admin',
        hideHeader: false,
        hideFooter: true,
        hideHelp: true
      },
      children: [
        /* {
          name: 'event',
          path: '/',
          component: () => import('@/components/admin/EditEvent.vue'),
          meta: {
            layout: 'admin'
          }
        }, */
        {
          name: 'admin.setup',
          path: 'setup',
          component: () => import('@/views/admin/ShowSetup.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.event',
          path: 'event',
          alias: '',
          component: () => import('@/components/admin/EditEvent.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.shows',
          path: 'shows',
          component: () => import('@/components/admin/EventShows.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
          /* children: [
            {
              name: 'view-show',
              path: ':show-id',
              component: () =>
            }
          ] */
        },
        {
          name: 'admin.sponsors',
          path: 'sponsors',
          component: () => import('@/views/admin/AdminSponsorsSplit.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.entries',
          path: 'entries',
          component: () => import('@/components/admin/EventEntries.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.exhibitors',
          path: 'exhibitors',
          component: () => import('@/components/admin/EventExhibitors.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.check-in',
          path: 'check-in',
          component: () => import('@/components/admin/CheckInEntries.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.show-books',
          path: 'show-books',
          component: () => import('@/components/admin/ShowBooks.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.results',
          path: 'results',
          component: () => import('@/components/admin/Results.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.financial',
          path: 'financial',
          component: () => import('@/components/admin/FinancialTab.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.premiums',
          path: 'premiums',
          component: () => import('@/views/admin/PremiumPayoutVersionController.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.sale_order',
          path: 'sale_order',
          component: () => import('@/views/admin/SaleOrder.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.help',
          path: 'adminHelp',
          component: () => import('@/components/admin/HelpVideos.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true
          }
        },
        {
          name: 'admin.super',
          path: 'adminSuper',
          component: () => import('@/components/admin/SuperUser.vue'),
          meta: {
            layout: 'admin',
            hideHeader: true,
            hideFooter: true,
            hideHelp: true,
            noBottomPadding: true
          }
        }
      ]
    }
  ]
})
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  let currentUser = store.getters.getUserID
  let currentUserReal = store.state.user ? store.state.user : {}
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  let requiresUnAuth = to.matched.some(record => record.meta.requiresUnAuth)
  if (requiresUnAuth && currentUser) {
    next('/')
  } else if (requiresAuth && !currentUser) {
    notie.alert({
      type: 1,
      text: `You must be logged in to access this page`
    })
    next({
      path: '/signin',
      query: {
        redirectToName: to.name,
        redirectToPath: to.fullPath,
        redirectTo: to
      }
    })
  } else if (requiresAdmin && currentUserReal.role !== 'ADMIN') {
    notie.alert({
      type: 3,
      text: `Warning! Unauthorized Access Attempted`
    })
    next('/')
  } else next()

  // If there is a show in the Parameter - update the title and meta info
  if (to.params.show) {
    let showName = to.params.show
    // if last part is 4 digits then remove it from title
    if (showName.split('-').slice(-1)[0].length === 4) {
      showName = to.params.show.split('-').slice(0, -1).join('-').replaceAll('-', ' ').toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
    } else {
      showName = showName.replaceAll('-', ' ').toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
    }

    let title = showName + ' | Showman'
    to.meta.title = title

    // Update OG Image
    document.querySelector('meta[property="og:image"]').setAttribute('content', `https://og-image.vercel.app/${showName.replaceAll(' ', '%20')}.png?theme=dark&md=0&fontSize=150px&images=https%3A%2F%2Fassets.vercel.com%2Fimage%2Fupload%2Ffront%2Fassets%2Fdesign%2Fvercel-triangle-white.svg&widths=&heights=`)
    // Update OG Title
    document.querySelector('meta[property="og:title"]').setAttribute('content', title)
    window.prerenderReady = true
  } else {
    // Update OG Image
    document.querySelector('meta[property="og:image"]').setAttribute('content', 'https://res.cloudinary.com/showman/image/upload/c_scale,w_900/v1578268801/Showman_generic_og_image.png')
    // Update OG Title
    document.querySelector('meta[property="og:title"]').setAttribute('content', `Showman | Online Livestock Show Management (${to.name})`)
    window.prerenderReady = true
  }
})

router.onError(() => {
  notie.alert({
    type: 2,
    time: 4,
    text: `Please refresh your webpage. There is an update that needs to be loaded before you can continue.<br>If this issue continues you can take a screenshot and send by email to ${process.env.VUE_APP_SUPPORT_EMAIL}`
  })
  // // this.$honeybadger.notify(error)
})

export default router
